__webpack_require__.p = "https://corastatic.com/core-docs-qsa/latest/";